<script>
import appConfig from "@/app.config";
import { Divider } from 'element-ui'
import Multiselect from "vue-multiselect";


import PageHeader from "@/components/PageHeader";

import { mapGetters } from "vuex";

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { PageHeader, Multiselect, [Divider.name]: Divider },
  computed: {
    ...mapGetters('auth', { getCurrentOrganisation: "getCurrentOrganisation" }),
  },
  data() {
    return {
      show_filters: false,
      query_params: {
        archived: 'False',
        page: 1,
        page_size: 25,
        ordering: null,
        search: null,
      },

      previous_page: 1,

      searching: false,
      pauseWatchers: false,
      alertType: null,

      archived_options: [
        { label: 'View All', value: undefined },
        { label: 'Active', value: 'False' },
        { label: 'Archived', value: 'True' },
      ],
      void_options: [
        { label: 'View All', value: undefined },
        { label: 'Active', value: 'False' },
        { label: 'Void', value: 'True' },
      ],
      active_options: [
        { label: 'View All', value: undefined },
        { label: 'Active', value: 'True' },
        { label: 'Disabled', value: 'False' },
      ],
      enabled_options: [
        { label: 'View All', value: undefined },
        { label: 'Active', value: 'False' },
        { label: 'Disabled', value: 'True' },
      ],
      boolean_options: [
        { label: 'View All', value: undefined },
        { label: 'Yes', value: 'True' },
        { label: 'No', value: 'False' },
      ],
    }
  },
  watch: {
    query_params: {
      handler(newVal) {
        if (this.pauseWatchers) return;
        if (newVal.page == this.previous_page) {
          this.pauseWatchers = true;
          this.query_params.page = 1;
          this.previous_page = 1;
          setTimeout(() => {
            this.pauseWatchers = false;
            this.query();
          }, 100);
        } else {
          this.previous_page = newVal.page
          this.query();
        }
      },
      deep: true,
    },
  }
}
</script>

<template></template>